$(document).ready(function() {
  new nc.promokit.Preloader({
    'game': 'lineage2',
    'image': [
      '/promo/lineage2/history/2019/191213_pet/img/banner.png',
      '/promo/lineage2/history/2019/191213_pet/img/bg_footer.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_navi.png',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_1.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_2.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_3.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_4.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_5.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_6.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_1_7.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_2.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_3_1.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_3_2.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/bg_sec_4.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/btn_scroll.png',
      '/promo/lineage2/history/2019/191213_pet/img/btn_update.png',
      '/promo/lineage2/history/2019/191213_pet/img/bul_navi.png',
      '/promo/lineage2/history/2019/191213_pet/img/char_index.png',
      '/promo/lineage2/history/2019/191213_pet/img/date_index.png',
      '/promo/lineage2/history/2019/191213_pet/img/light_index.png',
      '/promo/lineage2/history/2019/191213_pet/img/navi_off.png',
      '/promo/lineage2/history/2019/191213_pet/img/navi_on.png',
      '/promo/lineage2/history/2019/191213_pet/img/player--pause.png',
      '/promo/lineage2/history/2019/191213_pet/img/player--play.png',
      '/promo/lineage2/history/2019/191213_pet/img/ptn.png',
      '/promo/lineage2/history/2019/191213_pet/img/tab_active.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/tab_off.jpg',
      '/promo/lineage2/history/2019/191213_pet/img/tit_index.png'
    ]
  });

  $(document).on('preloadend', function() {
    $('#container').css('opacity', 1).addClass('active');
    pageMain.init();
  });
});

var pageMain = (function() {
  var Motion;

  Motion = (function() {

    $('body').TopBtn();

    //스크롤
    var $container = $('#ucontainer'),
        $naviArea = $('#naviArea'),
        $contents = $('.scrollCont'),
        $scene = $('#index'),
        $menu = $('.navi li'),
        h,
        $btnScroll = $('.btn-scroll'),
        secIndex,
        currentIndex,
        movie = {},
        tl,
        targetTop = [];

    var initScreen = function() {
      h = $(window).height();
      $scene.height(h);
      $('#header').height(h);
      $.each($contents, function(idx) {
        var $target = $contents.eq(idx);
        targetTop[idx] = $target.offset().top;
      });
    };

    var effect = function() {
      tl = new TimelineMax();
      tl.addLabel('init');
      tl.add(function() {
        $('.light', '#header').removeClass('twink');
      }, 'init');
      tl.fromTo($('.date', '#header'), 1, {autoAlpha: 0, y: 30}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=0.8');
      tl.fromTo($('.tit', '#header'), 0.8, {autoAlpha: 0, y: 30, skewX: 5}, {autoAlpha: 1, y: 0, skewX: 0, ease: Power3.easeOut}, 'init+=1.2');
      tl.fromTo($('.text', '#header'), 0.8, {autoAlpha: 0, y: 30}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=2.35');
      tl.fromTo($('.banner', '#header'), 1.0, {autoAlpha: 0, y: -50}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=3.2');
      tl.fromTo($('.char', '#header'), 10, {autoAlpha: 1, x: 100}, {autoAlpha: 1, x: 0, ease: Power3.easeOut}, 'init+=0.3');
      tl.add(function() {
        $('.light', '#header').addClass('twink');
      }, 'init+=0.85');
    };
    //remote
    var setMenu = function() {
      $menu.removeClass('on');
      if (secIndex !== 0) {
        $menu.eq(secIndex - 1).addClass('on');
      }
      $naviArea.removeClass();
      $naviArea.addClass('menu-' + secIndex);
      if ($(window).scrollTop() >= 56) {
        $naviArea.addClass('fixed');
      }
      else {
        $naviArea.removeClass('fixed');
      }
    };

    //skill
    var swiper1 = new Swiper('.skill-area', {
      simulateTouch: false,
      loop: false,
      effect: 'fade'
    });
    swiper1.on('slideChange', function() {
      var current = swiper1.activeIndex;
      var previous = swiper1.previousIndex;
      switch (previous) {
        case 0:
          movie.skillMovie1.pause();
          break;
        case 1:
          movie.skillMovie2.pause();
          break;
        case 2:
          movie.skillMovie3.pause();
          break;
        case 3:
          movie.skillMovie4.pause();
          break;
        case 4:
          movie.skillMovie5.pause();
          break;
        case 5:
          movie.skillMovie6.pause();
          break;
      }
      $('.navi-skill a').eq(current).addClass('active').siblings().removeClass('active');
    });
    $('.navi-skill a').on('click', function(e) {
      e.preventDefault();
      var num = $(this).index();
      $(this).addClass('active').siblings().removeClass('active');
      swiper1.slideTo(num);
    });
    //setMovie
    var setMovie = function() {
      movie.mainMovie = new nc.promokit.Player({
        selector: '#player-index',
        videoId: 'https://vod.plaync.com/lineage2/update/1211/bg.mp4',
        mute: true,
        controls: false,
        coverClick: false,
        loop: true
      });
      movie.skillMovie1 = new nc.promokit.Player({
        selector: '#player-skill-1',
        videoId: 'OwRICMCTlDo',
        mute: false,
        autoPlay: false,
        controls: true,
        coverClick: true,
        loop: false
      });
      movie.skillMovie2 = new nc.promokit.Player({
        selector: '#player-skill-2',
        videoId: 'e7Dkf3t1u5g',
        mute: false,
        autoPlay: false,
        controls: true,
        coverClick: true,
        loop: false
      });
      movie.skillMovie3 = new nc.promokit.Player({
        selector: '#player-skill-3',
        videoId: 'OXz7VisrUkw',
        mute: false,
        autoPlay: false,
        controls: true,
        coverClick: true,
        loop: false
      });
      movie.skillMovie4 = new nc.promokit.Player({
        selector: '#player-skill-4',
        videoId: 'R6UGqKs_abU',
        mute: false,
        autoPlay: false,
        controls: true,
        coverClick: true,
        loop: false
      });
      movie.skillMovie5 = new nc.promokit.Player({
        selector: '#player-skill-5',
        videoId: 'zkRV6i9mUxY',
        mute: false,
        autoPlay: false,
        controls: true,
        coverClick: true,
        loop: false
      });
      movie.skillMovie6 = new nc.promokit.Player({
        selector: '#player-skill-6',
        videoId: 'A0sCLHqP51Q',
        mute: false,
        autoPlay: false,
        controls: true,
        coverClick: true,
        loop: false
      });
    };
    //setScroll
    var setScroll = function() {
      var scltop = $(window).scrollTop();

      if ((scltop + 98) < targetTop[1] || scltop === 0) {
        $menu.removeClass('on');
        $naviArea.removeClass();
        secIndex = 0;
        currentIndex = 0;
        //0
      }
      else if ((scltop + 98) < targetTop[2]) {
        secIndex = 1;
        currentIndex = 1;
        //1
      }
      else if ((scltop + 98) < targetTop[3]) {
        secIndex = 2;
        currentIndex = 2;
        //2
      }
      else if ((scltop + 98) < targetTop[4]) {
        secIndex = 3;
        currentIndex = 3;
        //3
      }
      else {
        secIndex = 4;
        currentIndex = 4;
        //4
      }
    };

    $(window).scroll(function() {
      $.each($contents, function(idx) {
        var $target = $contents.eq(idx);
        targetTop[idx] = $target.offset().top;
      });
      setScroll();
      setMenu();
    });

    $menu.on('click', 'a', function(e) {
      e.preventDefault();
      var target = $(this).attr('href'),
          offsetTop = $(target).offset().top;
      var $doc = $('html, body');
      $doc.stop()
          .animate({
            scrollTop: offsetTop - 98
          }, 800);
    });
    $btnScroll.on('click', function(e) {
      e.preventDefault();
      var target = $contents.eq(currentIndex + 1),
          offsetTop = $(target).offset().top;
      var $doc = $('html, body');
      $doc.stop()
          .animate({
            scrollTop: offsetTop - 98
          }, 800);
    });
    return {
      init: function() {
        initScreen();
        setScroll();
        setMenu();
        setMovie();
        movie.mainMovie.play();
        effect();
      }
    };
  })();
  return {
    init: function() {
      Motion.init();
    }
  };
})();



// WEBPACK FOOTER //
// ./src/js/index.js